import { Route, RouteGroup } from '@billow/easy-route'
import { view } from '@/utilities/view'
import concat from 'lodash/concat'

export default RouteGroup({

  prefix: '/booking',

  routes: concat(
    [
      Route('/index', 'bookings', view('booking/Index')),
    ],

    RouteGroup({
      parent: Route('/:booking', '', view('booking/Manager')),
      routes: [
        Route('manager', 'booking.manager', view('booking/manager/Booking')),
        Route('additional-billing', 'booking.addBilling', view('booking/manager/AddBilling')),
      ]
    })
  )
})